import {types} from "mobx-state-tree";
import CreateCode from "../create/CreateCodeDomain";
import {flow} from "mobx";

const CompleteState = types.model('CompleteState', {
  title: types.maybe(types.string),
  code: types.maybe(types.late(():IAnyModelType => CreateCode)),
  uuid: types.maybe(types.string),
  formHasErrors: types.optional(types.boolean, false),
  errorMessage: types.optional(types.string, ""),
})
.volatile(self => ({
  selectedCallback: types.fn,
  selectedSecondCallback: types.fn,
  selectedThirdCallback: types.fn,
}))
  .actions((self) => ({
    handleHasCompleteErrors(boolean) {
      self.formHasErrors = boolean
    },
    handleCompleteErrorMessage(message) {
      self.errorMessage = message
    },
    setSecondCompleteStateListener(listener) {
      self.selectedSecondCallback = listener
    },
    setCompleteStateListener(listener) {
      self.selectedCallback = listener
    },
    setThirdCompleteStateListener(listener) {
      self.selectedThirdCallback = listener
    },
    notifyCallBack(){
      self.selectedCallback()
    },
    notifySecondCallBack(str) {
      self.selectedSecondCallback(str)
    },
    notifyThirdCallBack(str) {
      self.selectedThirdCallback(str)
    },
    completeCode: flow(function* () {
      self.notifySecondCallBack(self);
    }),
  }))

export default CompleteState;
